// extracted by mini-css-extract-plugin
export default {"label":"Search_label__mpPKv","input":"Search_input__agGH1"};